export const STREAMING_SUMMARY_TOPIC = 'audio-note.streaming-summary'

export interface StreamingSummarySnapshot {
  revision: number
  text: string
}

export const EMPTY_STREAMING_SUMMARY_SNAPSHOT: StreamingSummarySnapshot = {
  revision: 0,
  text: '',
}
